<template>
  <div
    class="w-full h-screen bg-white flex justify-center items-center flex-col font-montserrat text-indigo-base"
    data-testid="uhho-page"
  >
    <MagnifiyinGlassIcon />
    <h1 class="font-bold text-5xl mb-6">Uh-oh!</h1>
    <p class="text-base mb-6">
      There was an issue loading the information. Try refreshing the page, or
      contact
      <a href="mailto:productsupport@apiabroad.com" class="text-teal-900"
        >productsupport@apiabroad.com</a
      >
      if the issue continues.
    </p>
    <ButtonWithSpinner
      id="try-again-button"
      ref="tryAgainButton"
      data-testid="try-again-button"
      type="button"
      variant="secondary"
      :grey-disabled-class="true"
      :custom-class="'border-transparent uppercase font-bold bg-teal-900 text-white'"
      @click="handleButtonClick()"
    >
      <div
        class="flex gap-2 justify-center items-center font-semibold text-base"
      >
        <span>Try Again</span>
      </div>
    </ButtonWithSpinner>
  </div>
</template>

<script setup>
import MagnifiyinGlassIcon from "@/components/shared/icons/MagnifyingGlass.vue";
import ButtonWithSpinner from "@/components/forms/SharedComponents/ButtonWithSpinner.vue";
import { useRouter } from "vue-router";

const router = useRouter();

const handleButtonClick = () => {
  router.go();
};
</script>
